import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

function HeaderInfoIcon({ tooltipId, ariaLabel, e2eName = 'info-tooltip' }) {
  return (
    <ButtonWithIcon
      data-e2e={`info-tooltip-${e2eName}`}
      type="link"
      linkIconSize="s"
      sprite="InformationOutlineCircle"
      iconOnly
      className={`u-els-margin-left-1o2 e2e-${e2eName} info-tooltip`}
      onClick={() => {}}
      data-for={tooltipId}
      data-event="click"
      data-tip
      aria-label={ariaLabel}>
      {ariaLabel}
    </ButtonWithIcon>
  );
}

export default HeaderInfoIcon;

HeaderInfoIcon.propTypes = {
  tooltipId: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  e2eName: PropTypes.string,
};
